import {
  canShowScopedResource,
  type ResourceScope,
  type ResourceStatus,
} from '../scopedResource';

export const canShowTextList = ({
  pageOwnerAui,
  listOwnerAui,
  listScope,
  currentScope,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  listOwnerAui: string | null;
  listScope: ResourceScope | null;
  currentScope: ResourceScope;
  status: ResourceStatus;
}): boolean =>
  canShowScopedResource({
    pageOwnerAui,
    resourceOwnerAui: listOwnerAui,
    resourceScope: listScope,
    currentScope,
    status,
  });
